import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import translationEN from "./locales/en/translation.json";
import translationPL from "./locales/pl/translation.json";
import translationDE from "./locales/de/translation.json";
import translationES from "./locales/es/translation.json";
import translationFR from "./locales/fr/translation.json";
import translationUA from "./locales/ua/translation.json";
import { appLangFromPath } from "./utils/localizedRoutes";

const resources = {
  en: { translation: translationEN },
  pl: { translation: translationPL },
  de: { translation: translationDE },
  es: { translation: translationES },
  fr: { translation: translationFR},
  ua: { translation: translationUA},
};

// --- funkcja wykrywająca język na start
function detectInitialLanguage() {
  // 0️⃣ adres z językiem (/en/..., /uk/...) ma pierwszeństwo - tak trafiają ludzie z Google
  const urlLang = appLangFromPath(window.location.pathname);
  if (urlLang) return urlLang;

  // 1️⃣ najpierw sprawdź, czy użytkownik wybrał język wcześniej
  const savedLang = localStorage.getItem("i18nextLng");
  if (savedLang) return savedLang;

  // 2️⃣ inaczej wykryj język z przeglądarki
  const browserLang = navigator.language || navigator.userLanguage; // np. "pl-PL"
  let shortLang = (browserLang || "").split("-")[0].toLowerCase(); // "pl", "de", "en", "es"
  // ISO 639-1 dla ukraińskiego to "uk", w aplikacji używamy klucza "ua"
  if (shortLang === "uk") shortLang = "ua";

  // 3️⃣ jeśli obsługiwany → użyj, jeśli nie → fallback
  if (["pl", "de", "en", "es", "fr", "ua"].includes(shortLang)) return shortLang;

  return "pl"; // domyślnie polski
}

i18n
  .use(initReactI18next)    // integracja z React
  .use(LanguageDetector)    // wykrywanie języka przeglądarki
  .init({
    resources,
    lng: detectInitialLanguage(),  // <-- automatyczny wybór
    fallbackLng: "pl",             // jeśli tłumaczenie nie istnieje
    interpolation: { escapeValue: false },
    detection: {
      // pozwala pamiętać wybór użytkownika w localStorage
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },
  });

export default i18n;
